import { useEffect } from 'react';

import { useTokenStorage } from '@/js/libs/use-auth';

const PERMITTED_DOMAINS = ['http://localhost:3000', 'https://dienstag.adconsole.com'];

const useExternalTokenListener = () => {
  const { storeAuthToken } = useTokenStorage();

  useEffect(() => {
    // Receiving message from other domain
    const handleReceiveMessage = (event: MessageEvent) => {
      if (PERMITTED_DOMAINS.includes(event.origin) && event.data) {
        storeAuthToken(event.data);
      }
    };

    window.addEventListener('message', handleReceiveMessage);

    return () => window.removeEventListener('message', handleReceiveMessage);
  }, [storeAuthToken]);
};

export default useExternalTokenListener;
